import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, map, of, switchMap } from 'rxjs';
import { ComplianceFormPermissions } from 'src/app/permissions/permissions';
import { ComplianceFormService } from '../../services/compliance-form/compliance-form.service';
import {
  IRouteData,
  PermissionsService,
} from '../../services/permissions/permissions.service';
import * as ComplianceFormAction from './compliance-form.actions';
import * as EnrollmentsActions from '../enrollments/enrollments.actions';

@Injectable()
export class ComplianceFormEffects {
  getComplianceForm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        ComplianceFormAction.GetComplianceForm,
        EnrollmentsActions.GetAllEnrollmentsSuccess,
      ),
      switchMap(() =>
        this.permissionsService.hasRoutePermission(
          ComplianceFormPermissions as IRouteData,
        ),
      ),
      filter(Boolean),
      switchMap(() =>
        this.complianceFormService.getComplianceQuestionAnswers().pipe(
          map((complianceForm) =>
            ComplianceFormAction.GetComplianceFormSuccess({ complianceForm }),
          ),
          catchError((error) =>
            of(ComplianceFormAction.GetComplianceFormError({ error })),
          ),
        ),
      ),
    ),
  );

  updateComplianceFormData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ComplianceFormAction.UpdateComplianceFormData),
      switchMap(({ data }) =>
        this.complianceFormService.patchComplianceQuestionAnswers(data).pipe(
          map(() => ComplianceFormAction.UpdateComplianceFormDataSuccess()),
          catchError((error) =>
            of(ComplianceFormAction.UpdateComplianceFormDataError({ error })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private router: Router,
    private actions$: Actions,
    private store: Store,
    private complianceFormService: ComplianceFormService,
    private permissionsService: PermissionsService,
  ) {}
}
